export default __webpack_public_path__ + "images/1bdca45b74ee4943909b627b71c42db9-check-unchecked-large.svg";